// extracted by css-extract-rspack-plugin
export default {"cls1":"TagSelector-cls1_KGX","cls2":"TagSelector-cls2_LeJ TagSelector-cls1_KGX"};